import { render } from "./SingleChoiceStep.vue?vue&type=template&id=c6bce968"
import script from "./SingleChoiceStep.vue?vue&type=script&lang=js"
export * from "./SingleChoiceStep.vue?vue&type=script&lang=js"

import "./SingleChoiceStep.vue?vue&type=style&index=0&id=c6bce968&lang=scss"

import exportComponent from "/builds/lahautesociete/projects/roche/depistage-diabete/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__